import * as React from 'react';
import { Box, StyledInput } from '../';
import { ErrorMessage, FieldProps } from 'formik';
import { Span, Label } from '../../typography';
import { StyledSystemProps } from '../../theme/StyledSystemProps';
import tag from 'blacklist-tag';
import { theme } from '../../theme';

type FormGroupProps = FieldProps &
  StyledSystemProps & {
    label?: string;
    color?: string;
    placeholder?: string;
    type: string;
    disabled?: boolean;
    onInputChange?: (value: string) => void;
    backgroundColor?: string;
    autoComplete?: string;
    customIcon?: React.ReactNode;
    min?: number;
    max?: number;
  };

class FormGroup extends React.Component<FormGroupProps, {}> {
  static defaultProps = {
    mb: 3,
    width: '100%',
    type: 'text',
    flex: 1,
    minWidth: '150px',
  };
  render() {
    const {
      field,
      label,
      type,
      disabled,
      backgroundColor,
      placeholder,
      autoComplete,
      customIcon,
      min,
      max,
    } = this.props;
    return (
      <Box {...this.props}>
        <Label htmlFor={field.name}>{label}</Label>
        <Box justifyContent="center" flexDirection="row" alignItems="center">
          <StyledInput
            bg={backgroundColor || theme.colors.grayExtraLight}
            disabled={disabled}
            type={type}
            id={field.name}
            px={2}
            {...field}
            placeholder={placeholder || label}
            autoComplete={autoComplete}
            min={min}
            max={max}
          />
          {customIcon}
        </Box>
        <ErrorMessage name={field.name}>
          {(msg) => (
            <Span mt={2} color="error" textAlign="right">
              {msg}
            </Span>
          )}
        </ErrorMessage>
      </Box>
    );
  }
}

export const CleanFormGroup = tag(FormGroup, [
  'name',
  'form',
  'width',
  'display',
  'alignItems',
  'flexDirection',
  'justifyContent',
]);

export default CleanFormGroup;



// WEBPACK FOOTER //
// ./src/components/formElements/StyledFormGroup.tsx